// src/components/assets/ActionBar.tsx
import React from 'react';
import { Search, Download, Upload, Trash2 } from 'lucide-react';

interface ActionBarProps {
  searchTerm: string;
  onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
//   onExport: () => void;
//   onImport: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBulkDelete: () => void;
  selectedRowCount: number;
}

const ActionBar: React.FC<ActionBarProps> = ({ searchTerm, onSearchChange, onBulkDelete, selectedRowCount }) => {
  return (
    <div className="p-4 flex justify-between items-center flex-wrap gap-2">
      <div className="relative max-w-md">
        <input
          type="text"
          placeholder="Search asset records..."
          value={searchTerm}
          onChange={onSearchChange}
          className="w-full p-2 pl-10 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-green-600"
        />
        <Search className="w-5 h-5 absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
      </div>
      <div className="flex space-x-2 flex-wrap gap-2">
       
        {selectedRowCount > 0 && (
          <button onClick={onBulkDelete} className="bg-red-600 text-white py-2 px-4 rounded-lg hover:bg-red-700 flex items-center">
            <Trash2 className="w-4 h-4 mr-2" />Delete Selected ({selectedRowCount})
          </button>
        )}
      </div>
    </div>
  );
};

export default ActionBar;